export default __webpack_public_path__ + "static/media/jcb.11f8d3c2.svg";